// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';

// Components
// import Component from '~/components/componentName';

/**********
 ** Component: IconColor
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
const IconColor = props => {
	return (
		<Label htmlFor="color-input" color={props.color}>
			<ColorInput name="color-input" id="color-input" type="color" value={`${props.color}`} onChange={props.onChange} />
		</Label>
	);
};

const Label = styled.label`
	display: flex;
	flex-direction: row;
	border-radius: ${rem('24px')};
	width: ${rem('24px')};
	height: ${rem('24px')};
	padding: 0;
	border: 0;
	background-color: ${props => (props.color ? `${props.color}` : `#E0E1E6`)};
`;

const ColorInput = styled.input`
	display: none;
	visibility: hidden;
	width: 1px;
	height: 1px;
	position: relative;
`;

IconColor.defaultProps = {
	color: '#E0E1E6',
};

IconColor.propTypes = {
	color: PropTypes.string,
};

export default IconColor;



// WEBPACK FOOTER //
// ./src/components/ui/layout/icons/icon-color.jsx